export const SESSION_TOKEN = "sessionToken";
export const IS_AUTHENTICATED = "isAuthenticated";
export const NODE = "node";
export const USER = "user";
export const SUBSCRIPTION = "subscription";
export const COMMENT = "comment";
